<div
  class="p-5 gap-8 flex flex-col"
  *ngIf="!isLoading"
>
  <div>
    <h2>{{ action | action }} location</h2>
  </div>
  <div>
      <form class="flex flex-col gap-3" [formGroup]="locationForm" (ngSubmit)="onSubmit()">
          <mat-form-field class="w-full">
              <mat-label>Location Name</mat-label>
              <input
                      matInput
                      type="text"
                      formControlName="name"
                      placeholder="Location name"
                      (focus)="locationForm.controls.name.markAsUntouched()"
              />
              <mat-error
                      *ngIf="
          ValidationHelperService.isInvalid(locationForm.controls.name)
          "
              >
                  {{ValidationHelperService.getErrorMessage(locationForm.controls.name)}}
              </mat-error>
          </mat-form-field>
          <mat-form-field class="w-full">
              <mat-label>Country</mat-label>
              <input type="text"
                     placeholder="Select a country"
                     aria-label="Country"
                     matInput
                     [formControl]="locationForm.controls.country"
                     [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountry" (optionSelected)="onCountrySelected()">
                  <mat-option [value]="option" *ngFor="let option of filteredCountries">{{option.name}}</mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="ValidationHelperService.isInvalid(locationForm.controls.country)">
                  {{ValidationHelperService.getErrorMessage(locationForm.controls.country)}}
              </mat-error>
          </mat-form-field>
          <mat-form-field class="w-full">
              <mat-label>State</mat-label>
              <input type="text"
                     placeholder="Select a state"
                     aria-label="State"
                     matInput
                     [formControl]="locationForm.controls.state"
                     [matAutocomplete]="autoStates"
                     [readonly]="isLoadingStates"
              >
              <mat-autocomplete #autoStates="matAutocomplete" [displayWith]="displayState">
                  <mat-option [value]="option" *ngFor="let option of filteredStates">{{option.name}}</mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="ValidationHelperService.isInvalid(locationForm.controls.state)">
                  {{ValidationHelperService.getErrorMessage(locationForm.controls.state)}}
              </mat-error>
          </mat-form-field>
          <div class="flex justify-end">
              <button
                      mat-flat-button
                      color="primary"
                      [disabled]="!locationForm.valid || allreadyPressed"
              >
                  Submit
              </button>
          </div>
      </form>
  </div>
</div>
<div
  *ngIf="isLoading"
  class="w-full h-[300px] flex justify-center items-center"
>
  <mat-spinner diameter="50"></mat-spinner>
</div>
